import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function AboutUsHeader() {
  return (
    <>
      <div
        className="page-header page-header-small"
        style={{
          backgroundImage:
            "url(" +
            require("assets/img/sections/gerrit-vermeulen.jpg").default +
            ")",
        }}
      >
        <div className="filter filter-danger" />
        <div className="content-center">
          <Container>
            <h1>
              Conheça nossa História
            </h1>
            <h3>Saiba um pouco mais do que fazemos</h3>
          </Container>
        </div>
      </div>
    </>
  );
}

export default AboutUsHeader;
